export const httpErrorCodes = {
  BAD_REQUEST: '400',
  UNAUTHORIZED: '401',
  FORBIDDEN: '403',
  NOT_FOUND: '404',
  UNPROCESSABLE_ENTITY: '422',
  METHOD_NOT_ALLOWED: '405',
  INTERNAL_SERVER_ERROR: '500',
  SERVICE_UNAVAILABLE: '503',
};

export const pageName = {
  ACCOUNTS_PAGE: 'ACCOUNTS_PAGE',
  TEAMS_PAGE: 'TEAMS_PAGE',
  WORKSPACE_PAGE: 'WORKSPACE_PAGE',
  COHORT_OVERVIEW: 'COHORT_OVERVIEW',
  COHORT_PAGE:'COHORT_PAGE',
  COHORT_COURSEWARE_PAGE: 'COHORT_COURSEWARE_PAGE',
  ACTIVITY_EDITOR_PAGE: 'ACTIVITY_EDITOR_PAGE',
  OWNER_WORKSPACES_PAGE: 'OWNER_WORKSPACES_PAGE',
  ACTIVITY_BUILDER: 'ACTIVITY_BUILDER',
  COURSE_COMPETENCY_PAGE: 'COURSE_COMPETENCY_PAGE',
  COURSE_CONTENT_PAGE: 'COURSE_CONTENT_PAGE',
  COURSE_SCORING_PAGE: 'COURSE_SCORING_PAGE',
  KNOWLEDGE_BUILDER_PAGE: 'KNOWLEDGE_BUILDER_PAGE',
  CONTENT_PAGE: 'CONTENT_PAGE',
  LESSON_BUILDER_PAGE: 'LESSON_BUILDER_PAGE',
  SCREEN_EDITOR_PAGE: 'SCREEN_EDITOR_PAGE',
};
